import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/vhe/auxiliaries/client-types/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/vhe/auxiliaries/client-types/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/vhe/auxiliaries/client-types/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/vhe/auxiliaries/client-types/create`,  data)
    },
    update(data) {
        return axios.post(`/vhe/auxiliaries/client-types/update`,  data)
    },
    delete(id) {
        return axios.delete(`/vhe/auxiliaries/client-types/delete/${id}`)
    },
}